import {
  CLOSE_HEADER_DROPDOWNS,
  SHOW_HEADER_DROPDOWN,
  TOGGLE_PEAKED,
  TOGGLE_SIDEBAR,
  UPDATE_VIEW_TYPE,
  VIDEO_DOWNLOADING,
  VIDEO_DOWNLOADING_PROGRESS,
  VIDEO_DOWNLOADING_RESET,
} from '../constants/actions';

const DEFAULT_HEADER_STATE = {
  dropdown_menu_name: '',
  peaked: false,
  sidebar_open: false,
  is_mobile_view: false,
  downloading_video: false,
  downloading_percent: 0,
};

const headerReducer = (state = DEFAULT_HEADER_STATE, action) => {
  switch (action.type) {
    case CLOSE_HEADER_DROPDOWNS:
      return {
        ...state,
        dropdown_menu_name: '',
      };
    case SHOW_HEADER_DROPDOWN:
      return {
        ...state,
        dropdown_menu_name: action.name,
      };
    case TOGGLE_PEAKED:
      return {
        ...state,
        peaked: !state.peaked,
      };
    case TOGGLE_SIDEBAR:
      return {
        ...state,
        sidebar_open: !state.sidebar_open,
      };
    case UPDATE_VIEW_TYPE:
      return {
        ...state,
        is_mobile_view: action.is_mobile,
      };
    case VIDEO_DOWNLOADING:
      return {
        ...state,
        downloading_video: action.isDownloading,
      };
    case VIDEO_DOWNLOADING_PROGRESS:
      return {
        ...state,
        downloading_percent: action.percent,
      };
    case VIDEO_DOWNLOADING_RESET:
      return {
        ...state,
        downloading_video: false,
        downloading_percent: 0,
      };
    default:
      return state;
  }
};

export default headerReducer;
